import { render, staticRenderFns } from "./GlInputDate.vue?vue&type=template&id=5f6fc552&"
import script from "./GlInputDate.vue?vue&type=script&lang=js&"
export * from "./GlInputDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports